import React from "react";
import MultiSelectField from "./MultiSelectField";

export default function SelectSkills({ options, ...field }) {
  return <MultiSelectField {...field} options={options} />;
}
